import { render, staticRenderFns } from "./ModalCalendarStudent.vue?vue&type=template&id=31e33b54&"
import script from "./ModalCalendarStudent.vue?vue&type=script&lang=js&"
export * from "./ModalCalendarStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports